import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateEmspUserOcpiTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/create-emsp-user-ocpi-token.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useCreateEmspBoEmspUserOcpiTokenContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserOcpiTokenCreateFormStep1Controller } from '../emsp-bo-emsp-user-ocpi-token-create-form-step-1/emsp-bo-emsp-user-ocpi-token-create-form-step-1.controller';

interface EmspBoEmspUserOcpiTokenCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateEmspUserOcpiTokenModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateEmspUserOcpiTokenModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoEmspUserOcpiTokenCreateFormController = (
  props: EmspBoEmspUserOcpiTokenCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useCreateEmspBoEmspUserOcpiTokenContext();

  return (
    <MultiStepFormProvider<CreateEmspUserOcpiTokenModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['type', 'language', 'isActivated', 'isRevoked'],
          component: <EmspBoEmspUserOcpiTokenCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
